module.exports = __webpack_public_path__ + "img/GYLFW_4.197a9f76.jpg";